export default class NewAccountFormEntry {
    public files: File[] = [];
    public firstname: string = "";
    public lastname: string = "";
    public email: string = "";
    
    public fileNumber: string = "";
    
    public consent : boolean = false;
}